'use strict';

var _ = require('lodash');

var distanceConverter = {
  distance_types: [{
    id: 1,
    name: 'Mi',
    converter: 1609.344,
    ctLiveUnit: 'miles'
  }, {
    id: 2,
    name: 'in',
    converter: 0.0254,
    ctLiveUnit: 'inches'
  }, {
    id: 3,
    name: 'ft',
    converter: 0.3048,
    ctLiveUnit: 'feet'
  }, {
    id: 4,
    name: 'Yd',
    converter: 0.9144
  }, {
    id: 6,
    name: 'M',
    converter: 1,
    ctLiveUnit: 'meters'
  }, {
    id: 7,
    name: 'K',
    converter: 1000,
    ctLiveUnit: 'kilometers'
  }],

  getById: function getById(id) {
    var distance = _.find(this.distance_types, { id: id });
    return distance;
  },
  getByCtLiveUnit: function getByCtLiveUnit(unit) {
    var distance = _.find(this.distance_types, { 'ctLiveUnit': unit });
    return distance;
  },
  distanceTo: function distanceTo(distance, distance_id, to_id) {
    if (to_id != distance_id && distance_id != 0) {
      var distance_type = this.getById(distance_id);
      var to_type = this.getById(to_id);

      distance = distance * (distance_type.converter / to_type.converter);
    }

    return distance;
  },
  getDistanceFromCTLiveRace: function getDistanceFromCTLiveRace(unit, value) {
    var distanceType = this.getByCtLiveUnit(unit) || this.getById(6);

    var distance = this.distanceTo(value, 6, distanceType.id);

    return {
      value: distance,
      unit: distanceType.name,
      displayValue: distance + distanceType.name
    };
  }
};

module.exports = distanceConverter;


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/distanceConverter.js
// module id = 101
// module chunks = 0